import appStore from "store";
import api from "./api";
import { PAGINATION } from "./constants";

const store = {
  namespaced: true,
  state: {
    userList: [],
    detailList: [],
    coinList: [],
    totalCount: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,
  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list ? payload.list.slice() : [];
      state.totalCount = payload.totalCount || 0;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDetailList(state, payload) {
      state.detailList = payload.list ? payload.list.slice() : [];
      state.detailTotalCount = payload.totalCount || 0;
    },
    setCoinList(state, payload) {
      state.coinList = payload || [];
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit("setPagination", { page: query.page, size: query.size });
      api.getUserList(query).then((res) => {
        if (res.code == 0) {
          commit("setUserList", res.data);
        }
      });
    },
    exportExcel(_, data) {
      return api.exportExcel(data).then((res) => res);
    },
    addRemark(_, data) {
      return api.addRemark(data).then((res) => res);
    },
    getDetail({ commit }, data) {
      api.getDetail(data).then((res) => {
        if (res.code == 0) {
          commit("setDetailList", res.result);
        }
      });
    },
    getCoinList({ commit }) {
      api.getCoinList().then((res) => {
        if (res.code == 0) {
          commit("setCoinList", res.data);
        }
      });
    },
  },
};

appStore.registerModule("contractBill", store);
